
























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import PencilIcon from 'mdi-vue/SquareEditOutline';
import SettingIcon from 'mdi-vue/CogOutline';
import EyeIcon from 'mdi-vue/Eye';
import { VPopover } from 'v-tooltip';

@Component({
  components: {
    PencilIcon,
    EyeIcon,
    SettingIcon,
    VPopover,
  },
})
export default class ActionPopup extends Vue {
  @Prop(Boolean) detailAction!: boolean;
  @Prop(Boolean) captureAction!: boolean;
  @Prop(Boolean) voidAction!: boolean;
  @Prop(Boolean) refundAction!: boolean;
  @Prop(Boolean) matchAction!: boolean;
  @Prop(Boolean) settingAction!: boolean;
  @Prop(String) buttonWording!: string;

  detailClick() {
    this.$emit('detailClick');
  }

  settingClick() {
    this.$emit('settingClick');
  }

  captureClick() {
    this.$emit('captureClick');
  }

  voidClick() {
    this.$emit('voidClick');
  }

  refundClick() {
    this.$emit('refundClick');
  }

  matchClick() {
    this.$emit('matchClick');
  }
}
